export const SectionBackground = ({
  children,
  className,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <section className={`bg-white dark:bg-neutral-900 ${className} relative`}>
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute w-[900px] h-[600px] max-h-[90%] left-[35%] top-[45%] translate-x-[-50%] translate-y-[-50%] bg-[radial-gradient(50%_50%_at_center,rgba(239,98,37,0.3)_0%,rgba(171,171,171,0)_100%)] dark:bg-[radial-gradient(50%_50%_at_center,rgba(239,98,37,0.2)_0%,rgba(0,0,0,0)_100%)]"
        />
        <div
          className="absolute w-[800px] h-[600px] max-h-[80%] left-[50%] top-[40%] translate-x-[-50%] translate-y-[-50%] bg-[radial-gradient(50%_50%_at_center,rgba(129,53,138,0.25)_0%,rgba(171,171,171,0)_100%)] dark:bg-[radial-gradient(50%_50%_at_center,rgba(129,53,138,0.2)_0%,rgba(0,0,0,0)_100%)]"
        />
        <div
          className="absolute w-[600px] h-[400px] max-h-[100%] left-[65%] top-[60%] translate-x-[-50%] translate-y-[-50%] bg-[radial-gradient(50%_50%_at_center,rgba(54,162,173,0.3)_0%,rgba(171,171,171,0)_100%)] dark:bg-[radial-gradient(50%_50%_at_center,rgba(54,162,173,0.2)_0%,rgba(0,0,0,0)_100%)]"
        />
      </div>
      <div className="relative z-10 w-full h-full">
      {children}
      </div>
    </section>
  );
};
